import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useQueryClient } from "@tanstack/react-query";
import useRequest from "@/lib/request/useRequest";
import { Organization } from "@/types/organization";
import AddEditOrganizationForm from "@/components/network/AddEditOrganizationForm";

export const Route = createFileRoute(
    "/dashboard/network/organizations/$organizationId",
)({
    component: RouteComponent,
});

function RouteComponent() {
    const { organizationId } = Route.useParams();
    const navigate = useNavigate();
    const queryClient = useQueryClient();
    const { useGetRequest } = useRequest();

    const orgQuery = useGetRequest<Organization>({
        url: `organizations/${organizationId}/`,
    });

    const handleClose = (shouldRefetch: boolean) => {
        if (shouldRefetch) {
            queryClient.invalidateQueries({ queryKey: ["organizations/"] });
        }
        navigate({
            to: "/dashboard/network/organizations",
            search: (prev) => prev,
        });
    };

    if (orgQuery.isLoading || !orgQuery.data) {
        return null;
    }

    return (
        <AddEditOrganizationForm
            existingOrganization={orgQuery.data}
            onClose={handleClose}
        />
    );
}
